module.exports = __webpack_public_path__ + "images/default_avatars/path@2x-90dec5810381d8c6b70a3fb5a763cc01.jpg";